type BillingExportRow = {
  project: string;
  employee: string;
  role: string;
  billableHoursMinutes: number;
  rate: number;
  actualCost: number;
  billableValue: number;
  expenses: number;
  margin: string;
  currency: string;
};

export async function downloadBillingSummaryExcel(params: {
  filterRows: [string, string][];
  dataRows: BillingExportRow[];
  baseFilename: string;
}): Promise<void> {
  const ExcelJS = (await import("exceljs")).default;
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Billing Summary");

  params.filterRows.forEach(([label, value]) => {
    sheet.addRow([label, value]);
  });
  sheet.addRow([]);

  const headers = [
    "Project",
    "Employee",
    "Role",
    "Billable Hrs",
    "Rate",
    "Actual Cost",
    "Billable Value",
    "Expenses",
    "Margin",
    "Currency",
  ];
  sheet.addRow(headers);
  const headerRow = sheet.getRow(sheet.rowCount);
  headerRow.font = { bold: true };

  params.dataRows.forEach(row => {
    const excelRow = sheet.addRow([
      row.project,
      row.employee,
      row.role,
      row.billableHoursMinutes / 1440,
      row.rate,
      row.actualCost,
      row.billableValue,
      row.expenses,
      row.margin,
      row.currency,
    ]);

    excelRow.getCell(4).numFmt = "[h]:mm";
    excelRow.getCell(5).numFmt = "#,##0.00";
    excelRow.getCell(6).numFmt = "#,##0.00";
    excelRow.getCell(7).numFmt = "#,##0.00";
    excelRow.getCell(8).numFmt = "#,##0.00";
    excelRow.getCell(9).numFmt = "0.00%";
  });

  const widths = [24, 24, 20, 14, 14, 14, 14, 14, 12, 10];
  widths.forEach((w, idx) => {
    sheet.getColumn(idx + 1).width = w;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${params.baseFilename}.xlsx`;
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
